/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Empty/view.blocks to change it.
import * as fromDesignTokens from 'Simple/DesignTokens'
import ImagePlaceholder from './ImagePlaceholder/index'
import React from 'react'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function Empty({
  children,
  viewPath = "/App/Account/Content/Patients/Content/Content/Sections/ActiveTab/Images/Content/Content/Content/Content/Images/Content/Images/Misc/Empty"
  
}) {
let dtSpaceS = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.s'
        })
  return (<React.Fragment
>
<div
  data-testid="Empty.Vertical"
  data-view-path={viewPath}
 style={{'--pt-1-4PwO0': typeof dtSpaceS === 'number' ? `${dtSpaceS}px` : dtSpaceS}}
 className={`views-block ${styles.Vertical}`}
>
<ImagePlaceholder
  viewPath={`${viewPath}/ImagePlaceholder`}
/>
</div>
{children}
</React.Fragment>)
}